import {useMemo, useCallback} from "react";

import CloseIcon from '@mui/icons-material/Close';

import {useNavigate} from "react-router-dom";

import {useConfigStore} from '../../../../../../../../Stores/config';
import {useNavigationStore} from '../../../../../../../../Stores/navigation';

import TitleWidget from '../../../../../../Widgets/Title'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs'
import TopPagePicture from '../../../../../../Widgets/TopPagePicture'
import FilterChip from '../../../../../../Widgets/FilterChip'
import LinksTile from '../../../../../../Widgets/LinksTile'
import Links from '../../../../../../Widgets/Links'

import './index.scss'

export default function Template(props) {
    const {content, config, children, widgets, permits, breadcrumbs} = props

    const {configs} = useConfigStore();
    const {contentLoading} = useNavigationStore()

    let hasCategories = false
    children.order.map(id => {
        if (hasCategories) return;

        if (children.list[id].category) {
            hasCategories = true;
        }
    })

    return <div className='LibraryListTemplate'>
        <TopPagePicture cutHeightForDesktop image={content.banner} hidden={config?.templateOptions?.topPagePictureHidden}/>
        {/* showSkeleton={contentLoading}  */}

        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle} />
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        {content.showPagination && <>
            <FilteredAuthor />
            <LinksTile
                // className="childrensListLinksLines"
                showSkeleton={contentLoading}
                showPagination={content.showPagination}
                // showFilters={content.showFilters}
                imgLoading={config?.templateOptions?.imgLoading}

                links={children}
                xs={6}
                md={2}

                src="poster"
                // label={(link) => <FilterChip value={link.region} config={config?.childrenOptions?.['book']?.fields?.region || configs.content.nodes['book'].fields.region} />}
                label={(link) => link._reading_by ? <span className='bookReading'>На читанні</span> : <></>}
                title={(link) => <div>
                    {link.author && <div className='bookAuthors'>{link.author}</div>}
                    {link.title && <div className='bookTitle'>{link.title}</div>}
                </div>}
            />
        </>}

        <Links className="nodesWidget" links={widgets.nodes} showSkeleton={contentLoading} />
    </div>
}

function FilteredAuthor() {
    const navigate = useNavigate();

    const author = useMemo(() => {
        let result;

        const url = new URL(window.location.href);
        const filters = url.searchParams.get('filters');
        if (filters) {
            const filtersList = JSON.parse(filters)
            filtersList.map(i => {
                if (i[0] === "author") result = i[2];
            })
        }

        return result;
    });

    const onAuthorFilterClose = useCallback(() => {
        const url = new URL(window.location.href);
        const filters = url.searchParams.get('filters');
        if (filters) {
            let result = []
            const filtersList = JSON.parse(filters);
            filtersList.map(filter => {
                if (filter[0] !== "author") {
                    result.push(filter)
                }
            })
            if (!result.length) url.searchParams.delete('filters');
            else url.searchParams.set('filters', result);

            navigate(url.pathname + url.search);
        }
    })

    if (!author) return <></>

    return <div className='labelWrap labelWrapAuthorFilters'>
        <div className="label">Книги автора:</div>
        <div className="labelValue">{author}</div>
        <CloseIcon className='close' onClick={onAuthorFilterClose} />
    </div>
}
